import type { z } from "zod/v4"
import { type DefaultValues, type FieldValues, useForm, type UseFormProps } from "react-hook-form"
// import { standardSchemaResolver } from '@hookform/resolvers/standard-schema';
import { zodResolver } from "@hookform/resolvers/zod"


export function useZodForm<TSchema extends z.ZodType<FieldValues, FieldValues>>({
  schema,
  defaultValues,
  ...useFormProps
}: {
  schema: TSchema
  defaultValues?: DefaultValues<z.input<TSchema>>
} & Omit<UseFormProps<z.input<TSchema>, unknown, z.output<TSchema>>, "defaultValues" | "resolver">) {
  return useForm<z.input<TSchema>, unknown, z.output<TSchema>>({
    resolver: zodResolver(schema),
    ...useFormProps,
    defaultValues
  })
}
